import {
  Message,
  RealTimeService,
} from "./../../service/websockets/realtime.service";
import { UntypedFormControl } from "@angular/forms";
import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Event, Router } from "@angular/router";
import moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { Utils } from "src/app/common/utils";
import { AllPatient } from "src/app/models/patient";
import { VproService } from "src/app/service/vpro/vpro.service";
import Swal from "sweetalert2";
import { environment } from "src/environments/environment";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ChatMessages } from "src/app/models/chat-model";
import { Physician } from "src/app/models/physician";
import { SocketsConnectionService } from "src/app/service/websockets/connection.service";
import { VedioHomeComponent } from "../vedio-components/home/home.component";
import { TypingStatus } from "src/app/models/typing-status";
import { Subscription } from "rxjs";

const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

@Component({
  selector: 'app-presc-temp-create',
  templateUrl: './presc-temp-create.component.html',
  styleUrls: ['./presc-temp-create.component.css']
})
export class PrescTempCreateComponent implements OnInit {
  @ViewChild("PDFModal", { static: true } as any) PDFModal: TemplateRef<any>;
  @ViewChild("home") videoComp: VedioHomeComponent;
  @ViewChild("onlineJoinCall", { static: true } as any)
  onlineJoinCall: TemplateRef<any>;
  @ViewChild("chatModalPhy", { static: true } as any)
  chatModalPhy: TemplateRef<any>;
  @ViewChild("joinChatNotification", { static: true } as any)
  joinChatNotification: TemplateRef<any>;
  public role = Utils.ROLE.PHYSICIAN;
  drid: any;
  org_code: any;
  prescriptionForm: UntypedFormGroup;
  prescription: UntypedFormArray;
  intakeFreqTypesList = Utils.INTAKE_FREQ_TYPE_LIST;
  intakefreqList: any = [];
  intakeList = Utils.INTAKE;
  patient: AllPatient;
  dateFormat = Utils.DATE_FORMAT;
  appointment: any;
  prescriptions: any;
  physicianDetail: Physician;
  medicineAuo: any;
  text = "";
  medicneAuo_id: any;
  medicneAuo_type: any;
  consultChecked: boolean = true;
  privacy: any;
  constructor(
    private utils: Utils,
    private modal: NgbModal,
    private service: VproService,
    private spinner: NgxSpinnerService,
    private _formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private realTimeService: RealTimeService
  ) { }

  ngOnInit() {
    this.prescriptionForm = this._formBuilder.group({
      tmpl_name: ["", Validators.required],
      pre_template_details: this._formBuilder.array([]),


    });

    this.getPhysicianDetails();
    this.addpPrescription();
  }

  addpPrescription() {
    this.prescription = this.prescriptionForm.get(
      "pre_template_details"
    ) as UntypedFormArray;
    this.prescription.push(this.createpPrescription());
    this.intakefreqList.push([]);
  }

  checkValue(event: any) {
    this.setConsultNow();
  }
  setConsultNow() {
    console.log("this.consultChecked", this.consultChecked);
    this.privacy = this.consultChecked;
  }
  createpPrescription(): UntypedFormGroup {
    return this._formBuilder.group({
      mname: ["", [Validators.required, Validators.maxLength(50)]],
      strength: ["", [Validators.required, Validators.maxLength(30)]],
      intake: ["", Validators.required],
      intakefreq: ["", Validators.required],
      intakefreq_type: ["", Validators.required],
      med_type: [""],
      med_id: [null],

    });
  }

  public removingCurrentPrescription(i: number): void {
    this.prescription.removeAt(i);
  }

  track(item: any, index: number) {
    return index;
  }

  freqTypeSelected(event, i) {
    this.intakeFreqTypesList.forEach((type) => {
      console.log("type", type.value);
      console.log("event", event.target.value);
      if (type.value == event.target.value)
        this.intakefreqList[i] = type.freq_options;
    });
    this.prescription.at(i).get("intakefreq").reset();
    if (event.target.value === "Whenever Required") {
      this.prescription
        .at(i)
        .get("intakefreq")
        .setValue(this.intakeFreqTypesList[2].freq_options[0]);
      this.prescription.at(i).get("intakefreq").updateValueAndValidity();
    }
  }

  getControl(field: string): UntypedFormControl {
    return this.prescriptionForm.get(field) as UntypedFormControl;
  }

  getControlLabel(type: number) {
    return this.prescriptionForm.controls[type].value;
  }

  patchValueforSummary() {
    if (this.appointment && this.appointment.consultation_summary) {
      this.prescriptionForm.patchValue({
        summary: this.appointment.consultation_summary,
      });
    }
  }

  medicinesFet(e, i) {
    let medi = e.target.value
    if (e.target.value.length >= 3) {
      let medicine = medi;
      let val = { medicine: medicine }
      if (val.medicine === '') {
        delete val.medicine;
      }
      this.service
        .fetchMedicineRecords(val)
        .subscribe(
          (res) => {
            let data = {}
            this.spinner.hide();
            this.medicineAuo = res;
            if (this.medicineAuo) {
              this.medicneAuo_id = this.medicineAuo[0].med_id;
              this.prescriptionForm.value.pre_template_details[i].med_id = this.medicineAuo[0].med_id;
              this.prescriptionForm.value.pre_template_details[i].med_type = this.medicineAuo[0].med_type;
            }
          },
          (error) => {
            this.spinner.hide();
            Utils.showToast("error", "Something went wrong. Please try again.");
          }
        );
    }

  }

  async fetch_medicine_id(data, i) {
    let medi = data
    let medicine = medi;
    let val = { medicine: medicine }
    if (val.medicine === '') {
      delete val.medicine;
    }
    this.service
      .fetchMedicineRecords(val)
      .subscribe(
        (res) => {
          // this.spinner.hide();
          this.medicineAuo = res;
          if (this.medicineAuo) {
            this.medicneAuo_id = this.medicineAuo[0].med_id;
            this.prescriptionForm.value.pre_template_details[i].med_id = this.medicineAuo[0].med_id;
            this.prescriptionForm.value.pre_template_details[i].med_type = this.medicineAuo[0].med_type;
          }
        },
        (error) => {
          this.spinner.hide();
          Utils.showToast("error", "Something went wrong. Please try again.");
        }
      );
  }

  sendPrescriptions(val) {
    let data = val;
    console.log("valval..", val);

    this.service
      .addPrescriptiontemplate(data)
      .subscribe((result) => {
        this.spinner.hide();
        this.refresh();
        Utils.showToast("success", "Prescription Template added successfully");
      });

  }



  sendPrescription() {
    let data = this.prescriptionForm.value;
    console.log(" this.prescriptionForm.value.pre_template_details[i].med_type", this.prescriptionForm.value.pre_template_details)
    data.dr_id = this.drid;
    data.org_code = this.org_code;
    data.privacy = this.privacy;
    this.spinner.show();
    this.prescriptionForm.value.pre_template_details.forEach(async (x, index) => {
      if (x.mname !== "") {
        await this.fetch_medicine_id(x.mname, index);
      }
    })

    setTimeout(x => {
      this.sendPrescriptions(data);
    }, 2000)

  }

  setFormValidators(i = 0) {
    if (
      this.prescription.at(i).get("mname").value !== "" ||
      this.prescription.at(i).get("strength").value !== "" ||
      this.prescription.at(i).get("intake").value !== "" ||
      this.prescription.at(i).get("intakefreq").value !== "" ||
      this.prescription.at(i).get("intakefreq_type").value !== ""
    ) {
      this.prescription.at(i).get("mname").setValidators(Validators.required);
      this.prescription
        .at(i)
        .get("strength")
        .setValidators(Validators.required);
      this.prescription
        .at(i)
        .get("intake")
        .setValidators([Validators.required]);
      this.prescription
        .at(i)
        .get("intakefreq")
        .setValidators([Validators.required]);
      this.prescription
        .at(i)
        .get("intakefreq_type")
        .setValidators([Validators.required]);
      if (!this.prescription.at(i).get("sdate").value)
        this.prescription.at(i).get("sdate").setErrors({ required: true });
      if (!this.prescription.at(i).get("edate").value)
        this.prescription.at(i).get("edate").setErrors({ required: true });
    } else {
      this.prescription.at(i).get("mname").clearValidators();
      this.prescription.at(i).get("strength").clearValidators();
      this.prescription.at(i).get("intake").clearValidators();
      this.prescription.at(i).get("intakefreq").clearValidators();
      this.prescription.at(i).get("intakefreq_type").clearValidators();
    }
    this.prescription.at(i).get("mname").updateValueAndValidity();
    this.prescription.at(i).get("strength").updateValueAndValidity();
    this.prescription.at(i).get("intake").updateValueAndValidity();
    this.prescription.at(i).get("intakefreq").updateValueAndValidity();
    this.prescription.at(i).get("intakefreq_type").updateValueAndValidity();
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title,
    });
  }

  gotoPage() {
    this.router.navigate(["/appointment/consultation"]);
  }

  getPhysicianDetails() {
    this.service.getPhysicianById(localStorage.getItem("uid")).subscribe(
      (result) => {

        this.physicianDetail = result;
        this.drid = result.u_id;
        this.org_code = result.org_code;
        console.log("this.drid", this.drid);
        console.log("this.org_code", this.org_code);
      },
      (error) => {
        console.log(error);
      }
    );
  }
  refresh(): void {
    window.location.reload();
  }


  enterSubmit(event) {
    if (event.keyCode == 13 && !event.shiftKey) {
      event.preventDefault();
      return true;
    }
  }





}